// Prefetch engine (the wow): the moment a node renders, the next node for
// every option is generated in the background, so descents feel instant.

import { PRI } from "../api/scheduler";
import { bus } from "./bus";
import { generateNode } from "./navigator";
import { state, type DecisionNode } from "./state";

// The headless eval harness disables prefetch: speculative calls would burn
// the shared rate budget without measuring anything the harness cares about.
let prefetchEnabled = true;
export function setPrefetchEnabled(v: boolean): void { prefetchEnabled = v; }

export function prefetchChildren(node: DecisionNode): void {
  if (!prefetchEnabled) return;
  node.options.forEach((_, i) => {
    if (node.childId[i] || node.prefetch[i]) return;
    node.prefetch[i] = { status: "loading", node: null };
    generateNode({ parentNode: node, optionIndex: i, priority: PRI.PREFETCH })
      .then((child) => {
        node.prefetch[i] = { status: "ready", node: child };
        // reflect readiness live if still viewing this node
        if (state.currentId === node.id) bus.emit("prefetch:ready", { index: i });
      })
      .catch(() => { node.prefetch[i] = { status: "error", node: null }; });
  });
}

export function waitForPrefetch(node: DecisionNode, i: number): Promise<DecisionNode> {
  return new Promise((resolve, reject) => {
    const started = performance.now();
    const tick = () => {
      const pf = node.prefetch[i];
      if (pf?.status === "ready") return resolve(pf.node!);
      if (pf?.status === "error") return reject(new Error("prefetch failed"));
      if (performance.now() - started > 8000) return reject(new Error("timeout"));
      // rAF in the browser; plain timer headless
      if (typeof requestAnimationFrame === "function") requestAnimationFrame(tick);
      else setTimeout(tick, 40);
    };
    tick();
  });
}
